import ExploreMoreRewards from './ExploreMoreRewards';

export default ExploreMoreRewards;
